// Copyright (c) 2018 Formidable
// MIT License
// https://github.com/FormidableLabs/urql/blob/410cc39af64614ffad8cc08994a1d9c2fb5559d1/src/utils/stringifyVariables.ts
var seen = new Set();
var stringify = function (x) {
    if (x === undefined) {
        return '';
    }
    else if (typeof x == 'number') {
        return isFinite(x) ? '' + x : 'null';
    }
    else if (typeof x !== 'object') {
        return JSON.stringify(x);
    }
    else if (x === null) {
        return 'null';
    }
    else if (x.toJSON) {
        return x.toJSON();
    }
    var out = '';
    if (Array.isArray(x)) {
        out = '[';
        for (var i = 0, l = x.length; i < l; i++) {
            if (i > 0)
                out += ',';
            var value = stringify(x[i]);
            out += value.length > 0 ? value : 'null';
        }
        out += ']';
        return out;
    }
    else if (seen.has(x)) {
        throw new TypeError('Converting circular structure to JSON');
    }
    var keys = Object.keys(x).sort();
    seen.add(x);
    out = '{';
    for (var i = 0, l = keys.length; i < l; i++) {
        var key = keys[i];
        var value = stringify(x[key]);
        if (value.length !== 0) {
            if (out.length > 1)
                out += ',';
            out += stringify(key) + ':' + value;
        }
    }
    seen.delete(x);
    out += '}';
    return out;
};
export var stringifyVariables = function (x) {
    seen.clear();
    return stringify(x);
};
//# sourceMappingURL=stringifyVariables.js.map